<template>
  <div class="page-container" :class="{ 'page-container--with-sidebar': isSidebarPresent }">
    <h1 class="page-title">Dodaj skupino uporabnikov</h1>
    <user-group-form v-show="!isLoading" @submit="submitUserGroup" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UserGroupForm from './forms/UserGroupForm'

export default {
  components: {
    UserGroupForm,
  },
  created () {
    this.initialize()
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState(['isLoading']),
  },
  methods: {
    ...mapActions('accountStore/userGroups/forms', ['initialize', 'reset', 'submitUserGroup']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/common';
</style>

